import { keyframes } from '@emotion/react';
import { getFontSize } from '../../../../constants/fontSizes';

const marqueeScroll = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
`;

export const livingRoomSectionStyles = () => {
  return {
    container: {
      position: 'relative',
      width: '100%',
      height: {xs: '200px', lg: '375px'},
      overflow: 'hidden',
    },
    backgroundImage: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      zIndex: 0,
    },
    colorOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: '#25262966',
      zIndex: 0.5,
      pointerEvents: 'none',
    },
    marqueeContainer: {
      position: 'absolute',
      top: '45%',
      left: 0,
      right: 0,
      transform: 'translateY(-50%)',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      zIndex: 1,
    },
    marqueeContent: {
      display: 'inline-flex',
      animation: `${marqueeScroll} 30s linear infinite`,
    },
    marqueeText: {
      fontFamily: 'Aurora',
      fontWeight: 700,
      fontSize: getFontSize(233),
      lineHeight: '300px',
      letterSpacing: '0%',
      textTransform: 'capitalize',
      color: 'secondary.main',
      whiteSpace: 'nowrap',
      paddingRight: '100px',
    },
  };
};

